import request from '@/utils/request'
export function getList(params) {
	return request.get('expert-audit/demonstration/list', {
		params
	})
}

export function getSortResult(params) {
	return request.get('expert-audit/demonstration/sort', {
		params
	})
}

export function exportSortResult(params) {
	return request.get('expert-audit/demonstration/export', {
		params
	})
}